import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-configuration-popover',
    templateUrl: './configuration-popover.component.html',
    styleUrls: ['./configuration-popover.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonicModule, TranslateModule]
})
export class ConfigurationPopoverComponent {

  @Input()
  options: Array<PopoverOption> = [];
  @Input()
  textSize!: string;

  constructor(private popoverController: PopoverController) { }

  closePopover(action: string): void {
    this.popoverController.dismiss({
      action
    }).catch();
  }
}

export interface PopoverOption {
  text: string;
  action: string;
  icon: string;
  color: string;
}

